import { render, staticRenderFns } from "./widget-show-vacation.vue?vue&type=template&id=56af86f6&"
import script from "./widget-show-vacation.vue?vue&type=script&lang=js&"
export * from "./widget-show-vacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports